import React, { useState } from 'react'
import { useNavigate } from "react-router-dom";

const Questionnaire = () => {
  const [showModal, setShowModal] = useState(true);
  const [selectedType, setSelectedType] = useState('normal'); // null, 'normal', or 'smart'
  const navigate = useNavigate();

  const handleRadioChange = (type) => {
    setSelectedType(type);
  };

  const handleQuestionnaireSelection = () => {
    if (selectedType === 'normal') {
      navigate("/client-portal/normal-questionnaire", {
        state: { questionnaireType: 'normal' }
      });
    } else if (selectedType === 'smart') {
      navigate("/client-portal/smart-questionnaire", {
        state: { questionnaireType: 'smart' }
      });
    }
    setShowModal(false);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    navigate("/client-portal"); // Return to home if modal is closed
  };

  return (
    <>
      <section className="main_wrapper section-bg-color detail_page setting_tab mx-auto" style={{ minHeight: 'calc(100vh - 54.5px)' }}>
        {/* <div className="container py-4">
          <h1>Questionnaire</h1>
        </div> */}
      </section>

      {/* Questionnaire Selection Modal */}
      <div
        className={`modal step1-modal fade sleeve ${showModal ? "show" : ""}`}
        data-bs-backdrop="false"
        style={{ display: showModal ? "block" : "none" }}
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered step1-modal-dialog"
          role="document"
        >
          <div className="modal-content step1-modal-content">
            <div className="modal-header border-0 step1-modal-header">
              <div>
                <h5
                  className="modal-title step1-modal-title"
                  id="questionnaireModalLabel"
                >
                  Choose Your Questionnaire Type ✨
                </h5>
                <p className="step1-modal-subtitle">Pick what works for you</p>
              </div>
              <button
                type="button"
                className="btn-close step1-modal-close"
                onClick={handleCloseModal}
                aria-label="Close"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="#6B7280"
                  viewBox="0 0 16 16"
                >
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg>
              </button>
            </div>
            <div className="modal-body step1-modal-body">
              <div className="step1-sleeve-cards">
                {/* Normal Questionnaire */}
                <div
                  className={`card step1-sleeve-card${selectedType === 'normal' ? " active" : ""}`}
                  onClick={() => handleRadioChange('normal')}
                >
                  <div className="form-check d-flex justify-content-between p-0">
                    <div>
                      <label
                        className="form-check-label fw-bold step1-sleeve-label"
                        htmlFor="normalQuestionnaire"
                      >
                        Normal Questionnaire
                      </label>
                      <span className="rounded-pill step1-sleeve-badge">
                        Clean & Simple
                      </span>
                      {/* <p className="step1-sleeve-desc">
                        Standard questionnaire format with straightforward questions
                      </p> */}
                    </div>
                    <div>
                      <div
                        className={`step1-radio${selectedType === 'normal' ? " checked" : ""}`}
                      >
                        {selectedType === 'normal' && (
                          <div className="step1-radio-dot" />
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Smart Questionnaire */}
                <div
                  className={`card step1-sleeve-card${selectedType === 'smart' ? " active" : ""}`}
                  onClick={() => handleRadioChange('smart')}
                >
                  <div className="form-check d-flex justify-content-between p-0">
                    <div>
                      <label
                        className="form-check-label fw-bold step1-sleeve-label"
                        htmlFor="smartQuestionnaire"
                      >
                        Smart Questionnaire ✨
                      </label>
                      <span className="rounded-pill step1-sleeve-badge smart">
                        AI Powered
                      </span>
                      {/* <p className="step1-sleeve-desc">
                        Advanced questionnaire with intelligent adaptive questions
                      </p> */}
                    </div>
                    <div>
                      <div
                        className={`step1-radio${selectedType === 'smart' ? " checked" : ""}`}
                      >
                        {selectedType === 'smart' && (
                          <div className="step1-radio-dot" />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer border-0 step1-modal-footer">
              <button
                type="button"
                className="btn w-100 step1-modal-go"
                onClick={handleQuestionnaireSelection}
                disabled={!selectedType}
              >
                Let's Go! 🚀
              </button>
            </div>
          </div>
        </div>
      </div>
      {showModal && <div className="modal-backdrop fade show"></div>}
    </>
  )
}

export default Questionnaire